import * as React from 'react';
import { Modal, StackLayout } from '@leagueplatform/genesis-core';

const MODAL_WIDTH = '476px';
const MODAL_PROPORTIONAL_HEIGHT = '77vh';

type AddEditDataModalContentContainerProps = {
  children: React.ReactNode;
};

export function AddEditDataModalContentContainer({
  children,
}: AddEditDataModalContentContainerProps) {
  return (
    <Modal.Content
      padding="$twoAndHalf $two"
      width={{ '@initial': MODAL_WIDTH, '@mobile': '100vw' }}
      css={{
        '.GDS-modal': {
          height: MODAL_PROPORTIONAL_HEIGHT,
          overflow: 'visible',
          '@mobile': {
            height: '100vh',
          },
        },
        '.GDS-modal-close-button': {
          color: '$onSurfaceIconPrimary',
          position: 'absolute',
          top: '$none',
          insetInlineStart: 'calc(100% + 15vw)',
          '@mobile': {
            insetInlineStart: 'unset',
            top: '$half',
          },
          '@mobileLandscape': {
            insetInlineStart: 'calc(100% + 5vw)',
          },
          '@tablet': {
            insetInlineStart: 'calc(100% + 10vw)',
          },
        },
        '.GDS-modal-overlay': {
          backgroundColor: '$interactiveBackgroundHovered',
        },
      }}
    >
      <StackLayout
        horizontalAlignment="stretch"
        spacing="$one"
        css={{
          maxHeight: `calc(${MODAL_PROPORTIONAL_HEIGHT} - $five)`,
          overflow: 'auto',
        }}
      >
        {children}
      </StackLayout>
    </Modal.Content>
  );
}
